import { context } from "./config";
export class BaseAPI {
  context = context;
  prefix = "";
  path = "/";
  version = "v1";

  constructor(options) {
    if (!options) return;
    if (typeof options === "string") this.path = options;
    else if (typeof options === "object") {
      const { path, prefix, context, version } = options;
      if (path !== undefined) this.path = path;
      if (prefix !== undefined) this.prefix = prefix;
      if (context !== undefined) this.context = context;
      if (version !== undefined) this.version = version;
    }
  }

  _getContext() {
    return this.context;
  }

  _getBasePath({ version } = {}) {
    return `${this._getContext()}${this.prefix}/api/${version || this.version}${
      this.path
    }`;
  }
}
